import React from "react";

export const Error404 = () => {
  return <div>No se pudo encontrar la página</div>;
};
